import React from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { openOrCloseGlobalDialog } from '../action/dialog/global-dialog';
import { openGlobalDialogsSelector } from '../reducers/global-dialog-selectors';

import { GLOBAL_DIALOGS } from './global-dialogs-config';

const mapStateToProps = (state: any) => ({
  openDialogs: openGlobalDialogsSelector(state),
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  actions: {
    closeDialog: (key: string) => dispatch(openOrCloseGlobalDialog(key, false)),
  },
});

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

type Props = StateProps & DispatchProps;

/**
 * Global dialogs are rendered into the app root and their open/closed state
 * is managed by Redux so that they are not dependent on other components being in the
 * dom or not.
 */
class GlobalDialogsComponent extends React.PureComponent<Props> {
  closeDialog = (key: string) => () => {
    this.props.actions.closeDialog(key);
  };

  render() {
    const { openDialogs } = this.props;

    return (
      <>
        {Object.keys(openDialogs).map((k) => {
          const dialog = Object.values(GLOBAL_DIALOGS).find((d) => d.key === k);
          if (!dialog) {
            return null;
          }
          const Component = dialog.component;
          // Use both close and onClose here because different dialogs have different APIs. We should clean this up and use an interface
          return (
            <Component
              key={k}
              {...openDialogs[k].context}
              close={this.closeDialog(k)}
              onClose={this.closeDialog(k)}
            />
          );
        })}
      </>
    );
  }
}

export const GlobalDialogs = connect(mapStateToProps, mapDispatchToProps)(GlobalDialogsComponent);
